export default "__VITE_ASSET__72827ae0__"